import React from 'react'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiType, FiList, FiImage, FiSquare, FiVideo, FiAlignLeft, FiAlignCenter, FiAlignRight, FiGrid } = FiIcons

const Toolbar = ({ 
  onAddElement, 
  selectedElements, 
  onAlignElements, 
  gridEnabled, 
  onToggleGrid, 
  snapEnabled, 
  onToggleSnap 
}) => {
  const tools = [
    { id: 'text', icon: FiType, label: 'Text', action: () => onAddElement('text') },
    { id: 'list', icon: FiList, label: 'List', action: () => onAddElement('list') },
    { id: 'image', icon: FiImage, label: 'Image', action: () => onAddElement('image') },
    { id: 'video', icon: FiVideo, label: 'Video', action: () => onAddElement('video') },
    { id: 'shape', icon: FiSquare, label: 'Shape', action: () => onAddElement('shape') }
  ]

  const alignments = [
    { id: 'left', icon: FiAlignLeft, label: 'Align Left', action: () => onAlignElements('left') },
    { id: 'center', icon: FiAlignCenter, label: 'Align Center', action: () => onAlignElements('center') },
    { id: 'right', icon: FiAlignRight, label: 'Align Right', action: () => onAlignElements('right') }
  ]

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-6">
          {/* Add Elements */}
          <div className="flex items-center space-x-1">
            <span className="text-sm font-medium text-gray-700 mr-3">Add:</span>
            {tools.map((tool) => (
              <button
                key={tool.id}
                onClick={tool.action}
                className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
                title={tool.label}
              >
                <SafeIcon icon={tool.icon} className="w-4 h-4" />
                <span>{tool.label}</span>
              </button>
            ))}
          </div>

          {/* Alignment Tools */}
          {selectedElements && selectedElements.length > 0 && (
            <div className="flex items-center space-x-1 border-l border-gray-300 pl-6">
              <span className="text-sm font-medium text-gray-700 mr-3">Align:</span>
              {alignments.map((alignment) => (
                <button
                  key={alignment.id}
                  onClick={alignment.action}
                  className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
                  title={alignment.label}
                >
                  <SafeIcon icon={alignment.icon} className="w-4 h-4" />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Grid and Snap Controls */}
        <div className="flex items-center space-x-4">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={gridEnabled}
              onChange={(e) => onToggleGrid(e.target.checked)}
              className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">Grid</span>
          </label>
          
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={snapEnabled}
              onChange={(e) => onToggleSnap(e.target.checked)}
              className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
            />
            <span className="text-sm text-gray-700">Snap</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default Toolbar